import React from "react";
import InvestorHeader from "../../stories/common/inv-list-header";
import styles from "./index.module.scss";
import InvestorListing from "./investor-listing";
import { TabPanel, TabView } from "primereact/tabview";
import InvestorMyAccounts from "./investor-my-accounts";
import {
  ToggleMyAccountsView,
  ToggleMyCheckoutsView
} from "../../utils/inv-exch-amplitude";

export default function Investors() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const handleTabChange = (e: { index: number }) => {
    setActiveIndex(e.index);
    if (e.index === 0) {
      ToggleMyCheckoutsView();
    } else if (e.index === 1) {
      ToggleMyAccountsView();
    }
  };
  return (
    <div className={styles.investorList}>
      <InvestorHeader />
      <TabView
        className={styles.tabView}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      >
        <TabPanel header="My Checkouts">
          <InvestorListing />
        </TabPanel>
        <TabPanel header="My Accounts">
          <InvestorMyAccounts />
        </TabPanel>
      </TabView>
    </div>
  );
}
